import React, { useState } from 'react';
import { useAlert } from 'react-alert';
import { Auth } from 'aws-amplify';
import * as Yup from 'yup';
import { ErrorMessage, Field, Formik } from 'formik';
import Base, { ContentContainer } from '../../components/Base';
import { Button, ButtonActionBack, DivActionBack, Form, FormControl, H1, Hint, ImgIconBack, InputError } from '../../assets/styles/GlobalStyles';
import { passwordValidation, verifyError } from '../../utils/verifyErrors';
import { Input } from '../../components/Base/Elements';
import IconBack from "../../assets/icon/icon-back.svg";
import { BgSelectAppWebForm, LogoContainer } from "../../components/Base/styled";
import LogoAppWebSelectFarm from "../../assets/images/fundo-rosa-cima.png";
import { translate } from '../../i18n/index';

const PasswordRecoveryAppWeb = ({ history }) => {
    const alert = useAlert();
    const hasUsername = history.location.state ? history.location.state.username : null;
    const hasPassword = history.location.state ? history.location.state.oldPassword : null;
    const [passwordValidate, setPasswordValidate] = useState({
        min: false,
        number: false,
    });

    function handleClickForgotPassword() {
        history.push({
            pathname: '/login',
            search: history.location.search,
        });
    }

    function checkDigitIsNumber(value) {
        return /^\d*$/.test(value);

    }


    return (
        <>
            <DivActionBack>
                <ButtonActionBack onClick={() => handleClickForgotPassword()} type="button">
                    <ImgIconBack src={IconBack} className="icon-back" alt="Button Back" />{translate('buttonActionBack')}
                </ButtonActionBack>
            </DivActionBack>
            <div>
                <LogoContainer
                    style={{ alignSelf: 'center' }}
                    rel="noopener noreferrer"
                    target="_self">
                    <BgSelectAppWebForm src={LogoAppWebSelectFarm} alt="Logo OnFarm" title="OnFarm" />
                </LogoContainer>
            </div>
            <Base width={430} marginTop="450" isAppWeb={true} backgroundForm={'#fff'}>
                <ContentContainer>
                    <Formik
                        enableReinitialize
                        initialValues={{
                            user: hasUsername,
                            password: '',
                            confirmPassword: ''
                        }}
                        validationSchema={Yup.object().shape({
                            password: Yup.string()
                                .required(translate('validateRequired'))
                                .min(6, translate('validatePasswordMin'))
                                .max(6, translate('validatePasswordMax'))
                                .matches(/^\d+$/, translate('validatePasswordOnlyNumbers')),
                            confirmPassword: Yup.string().when("password", {
                                is: val => (!!(val && val.length > 0)),
                                then: Yup.string().oneOf(
                                    [Yup.ref("password")],
                                    translate('validatePasswordNotEquals')
                                )
                            })
                        })}
                        onSubmit={async (values, actions) => {
                            if (values && hasPassword) {
                                try {
                                    const user = await Auth.signIn(hasUsername, hasPassword);
                                    await Auth.completeNewPassword(user, values.password);
                                    alert.show(translate('forgotPasswordExceptionPasswordChangedSuccessfully'), {
                                        closeCopy: 'Fechar',
                                    });
                                    history.push({
                                        pathname: '/login',
                                        search: history.location.search,
                                        state: {
                                            email: hasUsername,
                                        },
                                    });
                                } catch (e) {
                                    alert.show(verifyError(e.code, e.message), {
                                        closeCopy: 'Fechar',
                                    });
                                }
                            }
                            actions.setSubmitting(false);
                        }}>
                        {({ isSubmitting, handleChange }) => (
                            <Form>
                                <H1>{translate('newPasswordInputTitle')}</H1>
                                <>
                                    <FormControl>
                                        <Field
                                            type="password"
                                            name="password"
                                            onInput={(value) => {
                                                if (checkDigitIsNumber(value.target.value)) {
                                                    passwordValidation(value.target.value, setPasswordValidate);
                                                } else {
                                                    value.currentTarget.value = value.target.value.substr(0, value.target.value.length - 1);
                                                }
                                            }}
                                            placeholder={translate('inputNewPassword')}
                                            component={Input}
                                        />
                                        <ErrorMessage name="password" component={InputError} />
                                        <Hint>
                                            <div>{translate('inputPasswordHintTitle')}</div>
                                            <ul>
                                                <li className={`${passwordValidate.min ? 'complete' : ''}`}>
                                                    {translate('inputPasswordHint1')}
                                                </li>
                                            </ul>
                                        </Hint>
                                    </FormControl>
                                    <FormControl>
                                        <Field
                                            type="password"
                                            name="confirmPassword"
                                            onChange={handleChange}
                                            onInput={(value) => {
                                                if (!checkDigitIsNumber(value.target.value)) {
                                                    value.currentTarget.value = value.target.value.substr(0, value.target.value.length - 1);
                                                }
                                            }}
                                            placeholder={translate('inputConfirmNewPassword')}
                                            component={Input}
                                        />
                                        <ErrorMessage name="confirmPassword" component={InputError} />
                                    </FormControl>
                                </>

                                <FormControl>
                                    <Button type="submit" disabled={isSubmitting}>
                                        {isSubmitting ? translate('buttonSending') : translate('buttonSend')}
                                    </Button>
                                </FormControl>
                            </Form>
                        )}
                    </Formik>
                </ContentContainer>
            </Base>
        </>
    );
};

export default PasswordRecoveryAppWeb;
